import userService from "../shared/services/usersService";

const REQUEST_USERS = "REQUEST_USERS";
const RESPONSE_USERS = "RESPONSE_USERS";
const REQUEST_USERS_FAILURE = "REQUEST_USERS_FAILURE";

const requestUsersAction = () => {
  return {
    type: REQUEST_USERS,
  };
};

const responseUsersAction = (data) => {
  return {
    type: RESPONSE_USERS,
    data,
  };
};

const requestUsersFailureAction = (errors) => {
  return {
    type: REQUEST_USERS_FAILURE,
    errors,
  };
};

const getUsers = (options) => {
  return (dispatch) => {
    dispatch(requestUsersAction());

    userService
      .getUsers(options)
      .then((result) => {
        dispatch(responseUsersAction(result.data));
      })
      .catch((error) => {
        dispatch(requestUsersFailureAction(error.response));
      });
  };
};

const REQUEST_USER = "REQUEST_USER";
const RESPONSE_USER = "RESPONSE_USER";
const REQUEST_USER_FAILURE = "REQUEST_USER_FAILURE";

const requestUserAction = () => {
  return {
    type: REQUEST_USER,
  };
};

const responseUserAction = (data) => {
  return {
    type: RESPONSE_USER,
    data,
  };
};

const requestUserFailureAction = (errors) => {
  return {
    type: REQUEST_USER_FAILURE,
    errors,
  };
};

const getUser = (id) => {
  return (dispatch) => {
    dispatch(requestUserAction());

    userService
      .getUser(id)
      .then((result) => {
        dispatch(responseUserAction(result.data));
      })
      .catch((error) => {
        dispatch(requestUserFailureAction(error.response));
      });
  };
};

const REQUEST_USER_BLOCK_STATES = "REQUEST_USER_BLOCK_STATES";
const RESPONSE_USER_BLOCK_STATES = "RESPONSE_USER_BLOCK_STATES";
const REQUEST_USER_BLOCK_STATES_FAILURE = "REQUEST_USER_BLOCK_STATES_FAILURE";

const requestUserBlockStatesAction = () => {
  return {
    type: REQUEST_USER_BLOCK_STATES,
  };
};

const responseUserBlockStatesAction = (data) => {
  return {
    type: RESPONSE_USER_BLOCK_STATES,
    data,
  };
};

const requestUserBlockStatesFailureAction = (errors) => {
  return {
    type: REQUEST_USER_BLOCK_STATES_FAILURE,
    errors,
  };
};

const blockStates = (id, isBlocked) => {
  return (dispatch) => {
    dispatch(requestUserBlockStatesAction());

    userService
      .blockStates(id, isBlocked)
      .then((result) => {
        dispatch(responseUserBlockStatesAction(isBlocked));
      })
      .catch((error) => {
        dispatch(requestUserBlockStatesFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_USER = "REQUEST_CREATE_USER";
const RESPONSE_CREATE_USER = "RESPONSE_CREATE_USER";
const REQUEST_CREATE_USER_FAILURE = "REQUEST_CREATE_USER_FAILURE";

const requestCreateUserAction = () => {
  return {
    type: REQUEST_CREATE_USER,
  };
};

const responseCreateUserAction = (data) => {
  return {
    type: RESPONSE_CREATE_USER,
    data,
  };
};

const requestCreateUserFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_USER_FAILURE,
    errors,
  };
};

const createUser = (options) => {
  return (dispatch) => {
    dispatch(requestCreateUserAction());

    userService
      .createUser(options)
      .then((result) => {
        dispatch(responseCreateUserAction());
      })
      .catch((error) => {
        dispatch(requestCreateUserFailureAction(error.response));
      });
  };
};

const createUserLocalVersion = (options) => {
  return (dispatch) => {
    dispatch(requestCreateUserAction());

    userService
      .createUserLocalVersion(options)
      .then((result) => {
        dispatch(responseCreateUserAction());
      })
      .catch((error) => {
        dispatch(requestCreateUserFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_USER_PERMISSION = "REQUEST_CREATE_USER_PERMISSION";
const RESPONSE_CREATE_USER_PERMISSION = "RESPONSE_CREATE_USER_PERMISSION";
const REQUEST_CREATE_USER_PERMISSION_FAILURE = "REQUEST_CREATE_USER_PERMISSION_FAILURE";

const requestCreateUserPermissionAction = () => {
  return {
    type: REQUEST_CREATE_USER_PERMISSION,
  };
};

const responseCreateUserPermissionAction = (data, classPermission) => {
  return {
    type: RESPONSE_CREATE_USER_PERMISSION,
    data,
    classPermission,
  };
};

const requestCreateUserPermissionFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_USER_PERMISSION_FAILURE,
    errors,
  };
};

const createUserPermission = (id, options, classPermission) => {
  return (dispatch) => {
    dispatch(requestCreateUserPermissionAction());

    userService
      .createUserPermission(id, { permissionId: options.id })
      .then((result) => {
        dispatch(responseCreateUserPermissionAction(options, classPermission));
      })
      .catch((error) => {
        dispatch(requestCreateUserPermissionFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_USER_PERMISSION = "REQUEST_DELETE_USER_PERMISSION";
const RESPONSE_DELETE_USER_PERMISSION = "RESPONSE_DELETE_USER_PERMISSION";
const REQUEST_DELETE_USER_PERMISSION_FAILURE = "REQUEST_DELETE_USER_PERMISSION_FAILURE";

const requestDeleteUserPermissionAction = () => {
  return {
    type: REQUEST_DELETE_USER_PERMISSION,
  };
};

const responseDeleteUserPermissionAction = (data, classPermission) => {
  return {
    type: RESPONSE_DELETE_USER_PERMISSION,
    data,
    classPermission,
  };
};

const requestDeleteUserPermissionFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_USER_PERMISSION_FAILURE,
    errors,
  };
};

const deleteUserPermission = (id, options, classPermission) => {
  return (dispatch) => {
    dispatch(requestDeleteUserPermissionAction());

    userService
      .deleteUserPermission(id, { permissionId: options.id })
      .then((result) => {
        dispatch(responseDeleteUserPermissionAction(options, classPermission));
      })
      .catch((error) => {
        dispatch(requestDeleteUserPermissionFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_USER_OWNERSHIPAREA = "REQUEST_CREATE_USER_OWNERSHIPAREA";
const RESPONSE_CREATE_USER_OWNERSHIPAREA = "RESPONSE_CREATE_USER_OWNERSHIPAREA";
const REQUEST_CREATE_USER_OWNERSHIPAREA_FAILURE = "REQUEST_CREATE_USER_OWNERSHIPAREA_FAILURE";

const requestCreateUserOwnershipAreaAction = () => {
  return {
    type: REQUEST_CREATE_USER_OWNERSHIPAREA,
  };
};

const responseCreateUserOwnershipAreaAction = (data) => {
  return {
    type: RESPONSE_CREATE_USER_OWNERSHIPAREA,
    data,
  };
};

const requestCreateUserOwnershipAreaFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_USER_OWNERSHIPAREA_FAILURE,
    errors,
  };
};

const createUserOwnershipArea = (id, options) => {
  return (dispatch) => {
    dispatch(requestCreateUserOwnershipAreaAction());

    userService
      .createUserOwnershipArea(id, { ownershipAreaId: options.id })
      .then((result) => {
        dispatch(responseCreateUserOwnershipAreaAction(options));
      })
      .catch((error) => {
        dispatch(requestCreateUserOwnershipAreaFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_USER_OWNERSHIPAREA = "REQUEST_DELETE_USER_OWNERSHIPAREA";
const RESPONSE_DELETE_USER_OWNERSHIPAREA = "RESPONSE_DELETE_USER_OWNERSHIPAREA";
const REQUEST_DELETE_USER_OWNERSHIPAREA_FAILURE = "REQUEST_DELETE_USER_OWNERSHIPAREA_FAILURE";

const requestDeleteUserOwnershipAreaAction = () => {
  return {
    type: REQUEST_DELETE_USER_OWNERSHIPAREA,
  };
};

const responseDeleteUserOwnershipAreaAction = (data) => {
  return {
    type: RESPONSE_DELETE_USER_OWNERSHIPAREA,
    data,
  };
};

const requestDeleteUserOwnershipAreaFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_USER_OWNERSHIPAREA_FAILURE,
    errors,
  };
};

const deleteUserOwnershipArea = (id, options) => {
  return (dispatch) => {
    dispatch(requestDeleteUserOwnershipAreaAction());

    userService
      .deleteUserOwnershipArea(id, { ownershipAreaId: options.id })
      .then((result) => {
        dispatch(responseDeleteUserOwnershipAreaAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteUserOwnershipAreaFailureAction(error.response));
      });
  };
};

const CLEAR_CURRENT_USER = "CLEAR_CURRENT_USER";

const clrearCurrentuserAction = () => {
  return {
    type: CLEAR_CURRENT_USER,
  };
};

const clearCurrentUser = () => {
  return (dispatch) => {
    dispatch(clrearCurrentuserAction());
  };
};

const REQUEST_CREATE_USER_UNIT = "REQUEST_CREATE_USER_UNIT";
const RESPONSE_CREATE_USER_UNIT = "RESPONSE_CREATE_USER_UNIT";
const REQUEST_CREATE_USER_UNIT_FAILURE = "REQUEST_CREATE_USER_UNIT_FAILURE";

const requestCreateUserUnitAction = () => {
  return {
    type: REQUEST_CREATE_USER_UNIT,
  };
};

const responseCreateUserUnitaAction = (data) => {
  return {
    type: RESPONSE_CREATE_USER_UNIT,
    data,
  };
};

const requestCreateUserUnitFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_USER_UNIT_FAILURE,
    errors,
  };
};

const createUserUnit = (user, unit) => {
  return (dispatch) => {
    dispatch(requestCreateUserUnitAction());

    userService
      .createUserUnit({ userId: user.id, unitId: unit.id })
      .then((result) => {
        dispatch(responseCreateUserUnitaAction(unit));
      })
      .catch((error) => {
        dispatch(requestCreateUserUnitFailureAction(error));
      });
  };
};

const REQUEST_DELETE_USER_UNIT = "REQUEST_DELETE_USER_UNIT";
const RESPONSE_DELETE_USER_UNIT = "RESPONSE_DELETE_USER_UNIT";
const REQUEST_DELETE_USER_UNIT_FAILURE = "REQUEST_DELETE_USER_UNIT_FAILURE";

const requestDeleteUserUnitAction = () => {
  return {
    type: REQUEST_DELETE_USER_UNIT,
  };
};

const responseDeleteUserUnitaAction = (data) => {
  return {
    type: RESPONSE_DELETE_USER_UNIT,
    data,
  };
};

const requestDeleteUserUnitFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_USER_UNIT_FAILURE,
    errors,
  };
};

const deleteUserUnit = (user, unit) => {
  return (dispatch) => {
    dispatch(requestDeleteUserUnitAction());

    userService
      .deleteUserUnit({ userId: user.id, unitId: unit.id })
      .then((result) => {
        dispatch(responseDeleteUserUnitaAction(unit));
      })
      .catch((error) => {
        dispatch(requestDeleteUserUnitFailureAction(error));
      });
  };
};

const REQUEST_UPDATE_USER_PASSWORD = "REQUEST_UPDATE_USER_PASSWORD";
const RESPONSE_UPDATE_USER_PASSWORD = "RESPONSE_UPDATE_USER_PASSWORD";
const REQUEST_UPDATE_USER_PASSWORD_FAILURE = "REQUEST_UPDATE_USER_PASSWORD_FAILURE";

const requestUpdateUserPasswordAction = () => {
  return {
    type: REQUEST_UPDATE_USER_PASSWORD,
  };
};

const responseUpdateUserPasswordAction = () => {
  return {
    type: RESPONSE_UPDATE_USER_PASSWORD,
  };
};

const requestUpdateUserPasswordFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_USER_PASSWORD_FAILURE,
    errors,
  };
};

const updateUserPassword = (id, options) => {
  return (dispatch) => {
    dispatch(requestUpdateUserPasswordAction());

    userService
      .updatePasseord(id, options)
      .then((result) => {
        dispatch(responseUpdateUserPasswordAction());
      })
      .catch((error) => {
        dispatch(requestUpdateUserPasswordFailureAction(error));
      });
  };
};

export {
  REQUEST_USERS,
  RESPONSE_USERS,
  REQUEST_USERS_FAILURE,
  getUsers,
  REQUEST_USER,
  RESPONSE_USER,
  REQUEST_USER_FAILURE,
  getUser,
  REQUEST_USER_BLOCK_STATES,
  RESPONSE_USER_BLOCK_STATES,
  REQUEST_USER_BLOCK_STATES_FAILURE,
  blockStates,
  REQUEST_CREATE_USER,
  RESPONSE_CREATE_USER,
  REQUEST_CREATE_USER_FAILURE,
  createUser,
  createUserLocalVersion,
  REQUEST_CREATE_USER_PERMISSION,
  RESPONSE_CREATE_USER_PERMISSION,
  REQUEST_CREATE_USER_PERMISSION_FAILURE,
  createUserPermission,
  REQUEST_DELETE_USER_PERMISSION,
  RESPONSE_DELETE_USER_PERMISSION,
  REQUEST_DELETE_USER_PERMISSION_FAILURE,
  deleteUserPermission,
  REQUEST_CREATE_USER_OWNERSHIPAREA,
  RESPONSE_CREATE_USER_OWNERSHIPAREA,
  REQUEST_CREATE_USER_OWNERSHIPAREA_FAILURE,
  createUserOwnershipArea,
  REQUEST_DELETE_USER_OWNERSHIPAREA,
  RESPONSE_DELETE_USER_OWNERSHIPAREA,
  REQUEST_DELETE_USER_OWNERSHIPAREA_FAILURE,
  deleteUserOwnershipArea,
  CLEAR_CURRENT_USER,
  clearCurrentUser,
  REQUEST_CREATE_USER_UNIT,
  RESPONSE_CREATE_USER_UNIT,
  REQUEST_CREATE_USER_UNIT_FAILURE,
  createUserUnit,
  REQUEST_DELETE_USER_UNIT,
  RESPONSE_DELETE_USER_UNIT,
  REQUEST_DELETE_USER_UNIT_FAILURE,
  deleteUserUnit,
  REQUEST_UPDATE_USER_PASSWORD,
  RESPONSE_UPDATE_USER_PASSWORD,
  REQUEST_UPDATE_USER_PASSWORD_FAILURE,
  updateUserPassword,
};
